import React from 'react';
import { Accordion, List } from 'antd-mobile';
import '../../index.css';
import intl from 'react-intl-universal';


class effect extends React.Component {
    render() {
        return (
            <div className="body_pad">
                {intl.getHTML('effect')}
            </div>
        );
    }
}
export default effect;